import { venueGetUnreadNotificationCount } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueGetUnreadNotificationCountApi = async (venueID: string): Promise<number> => {
  const result = await executeGql<number>(venueGetUnreadNotificationCount, { venueID });
  return processGqlResult<number>('venueGetUnreadNotificationCount', result) ?? 0;
};
